import { Button } from "@pushpress/pushpress-ui";
import { CreditCard, FileText } from "lucide-react";
import { useSectionContext } from "../../hooks/useSectionContext";

export function BillingAlert() {
  const { scrollToSection } = useSectionContext();

  return (
    <div className="tw-bg-amber-50 tw-border tw-border-amber-200 tw-rounded-lg tw-p-4 tw-mb-1 tw-flex tw-items-center tw-justify-between">
      <div className="tw-flex tw-items-center tw-gap-3">
        <div className="tw-p-2 tw-rounded-full tw-bg-amber-100">
          <CreditCard className="tw-h-5 tw-w-5 tw-text-amber-600" />
        </div>
        <div>
          <p className="tw-text-amber-800 tw-font-[16px] tw-mb-1">
            Payment method expired
          </p>
          <p className="tw-text-xs tw-text-amber-700">
            This member has an expired payment method. Please see the billing
            section for more information.
          </p>
        </div>
      </div>
      <Button
        variant="outline"
        className="tw-border-amber-300 tw-text-amber-700 hover:tw-bg-amber-100 hover:tw-text-amber-800"
        onClick={() => {
          scrollToSection("billing", "smooth");
        }}
      >
        Update Payment
      </Button>
    </div>
  );
}

export function DocumentAlert() {
  const { scrollToSection } = useSectionContext();

  return (
    <div className="tw-bg-amber-50 tw-border tw-border-amber-200 tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-justify-between">
      <div className="tw-flex tw-items-center tw-gap-3">
        <div className="tw-p-2 tw-rounded-full tw-bg-amber-100">
          <FileText className="tw-h-5 tw-w-5 tw-text-amber-600" />
        </div>
        <div>
          <p className="tw-text-amber-800 tw-font-[16px] tw-mb-1">
            Unsigned documents
          </p>
          <p className="tw-text-xs tw-text-amber-700">
            This member has some unsigned documents. Please see the documents
            section for more information.
          </p>
        </div>
      </div>
      <Button
        variant="outline"
        className="tw-border-amber-300 tw-text-amber-700 hover:tw-bg-amber-100 hover:tw-text-amber-800"
        onClick={() => {
          scrollToSection("documents", "smooth");
        }}
      >
        Sign Documents
      </Button>
    </div>
  );
}
